import { useOpenLeads } from '@/api/b2b/getOpportunities';
import { useSnoozeLead } from '@/api/b2b/snooze';
import { Button } from '@/components/ui/elements/button';
import { leadUrgency } from '@/features/b2b/logic';
import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { OpportunityColumn } from './OpportunityColumn';
import { TypeBadge } from './TypeBadge';
import { UrgencyPill } from './UrgencyPill';

export const OpenLeadsColumn = () => {
  const [page, setPage] = useState(1);
  const { data, isPending } = useOpenLeads(page);
  const snooze = useSnoozeLead();

  const leads = data?.results ?? [];

  return (
    <OpportunityColumn
      testid="b2b-open-leads"
      title="Open Leads"
      subtitle="Brand new, due, or awaiting reply"
      total={data?.paginator.total ?? 0}
      isLoading={isPending}
      page={page}
      lastPage={data?.paginator.lastPage ?? 1}
      onPageChange={setPage}
      emptyLabel="No open leads right now."
    >
      {leads.map((lead) => {
        const urgency = leadUrgency(lead);
        return (
          <div key={lead.lead_id} className="rounded border p-2">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <span className="font-medium">{lead.name}</span>
                <TypeBadge label={lead.event_type_name} />
              </div>
              <UrgencyPill label={urgency.label} tone={urgency.tone} />
            </div>
            <div className="mt-0.5 text-xs text-muted-foreground">{lead.phone}</div>
            <div className="mt-2 flex justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                size="sm"
                disabled={snooze.isPending}
                onClick={() => snooze.mutate(lead.lead_id)}
              >
                Snooze
              </Button>
              <Button asChild size="sm">
                <Link to={`/leads/lead/${lead.lead_id}/quote`}>Open</Link>
              </Button>
            </div>
          </div>
        );
      })}
    </OpportunityColumn>
  );
};
